import { filterUnusedModelFiles } from "../../../helper/packageModelHelper";
import { getDefaultIndex } from "../../../helper/setDefaultName";

const defaultPairInfo = {
  libraryId: "",
  modelKey: "",
  node: "",
  subckt: ""
}

/**
 * 
 * @param {number | string} addIndex "start" | "end" | 0,1,2,...
 * @param {string} modelType 
 * @param {Array} components 
 * @param {Array} targetComps 
 */
function addNewModelToComponents(addIndex, modelType, components, targetComps) {
  function generateModelInfo(pins) {
    return {
      pairs: pins.map(item => ([{ ...defaultPairInfo, pin: item.pin }, { ...defaultPairInfo, pin: item.pin + "_u" }])).flat(),
      files: [],
      type: "Touchstone / SPICE",
      ...(modelType ? { modelType } : {})
    }
  }

  const targetCompNames = targetComps.map(item => item.name);
  const newComponents = components.map(item => {
    if (!targetCompNames.includes(item.name)) {
      return item;
    }

    const { modelList = [], pins } = item || {};
    const modelInfo = generateModelInfo(pins);
    let otherModelInfo = {};
    // if (modelType === DIE) {
    //   otherModelInfo = {
    //     termination: {
    //       pairs: pins.map(item => ({ ...defaultPairInfo, pin: item.pin, r: "50 ohm" })),
    //       files: [],
    //       type: "value"
    //     },
    //     topology: PARALLEL
    //   }
    // }
    const _addIndex = addIndex === "end" ? modelList.length : addIndex;
    modelList.splice(_addIndex, 0, { ...modelInfo, ...otherModelInfo });
    return { ...item, modelList }
  })

  return newComponents;
}

/**
 * 
 * @param {number} deleteIndex 
 * @param {Array} components 
 * @param {Array} targetComps 
 */
function deleteOldModelByComponents(deleteIndex, components, targetComps) {
  const targetCompNames = targetComps.map(item => item.name);
  const newComponents = components.map(item => {
    if (!targetCompNames.includes(item.name)) { return item }
    const { modelList = [] } = item || {};
    modelList.splice(deleteIndex, 1);
    return { ...item, modelList }
  })

  return newComponents;
}

/**
 * select/delete port 
 * @param {"add" | "delete"} changeType
 * @param {string} node 
 * @param {{libraryId, modelKey, subckt}} fileValue 
 * @param {{pin, comp}} pairInfo 
 * @param {number} modelIndex 
 * @param {Array} components 
 * @param {"object" | undefined} resType 
 * @param {"termination" | ""} otherKeyStr 
 * @returns 
 */
function changePort(changeType, { node, fileValue = {}, pairInfo, modelIndex, components }, resType, otherKeyStr) {
  const compIndex = components.findIndex(item => item.name === pairInfo.comp);
  if (compIndex < 0) return components;
  const { modelList = [] } = components[compIndex];
  // const oldPairs = otherKeyStr === DIE_TERMINATION ? modelList[modelIndex].termination.pairs : modelList[modelIndex].pairs;
  // const oldFiles = otherKeyStr === DIE_TERMINATION ? modelList[modelIndex].termination.files : modelList[modelIndex].files;
  const { pairs: oldPairs, files: oldFiles } = modelList[modelIndex];

  let isChangeFile = false, modelKey = fileValue.modelKey
  function judgeChangeFileInfo() {
    // if (otherKeyStr !== DIE_TERMINATION) {
    //   return;
    // }

    if (changeType === 'add') {
      isChangeFile = oldPairs.find(pair => pair.node === node && pair.libraryId === fileValue.libraryId && pair.modelKey === fileValue.modelKey);
    } else {
      isChangeFile = !oldPairs.find(pair => pair.pin !== pairInfo.pin && pair.libraryId === pairInfo.libraryId && pair.modelKey === pairInfo.modelKey);
    }
  }

  const newPairs = oldPairs.map(pair => {
    if (pair.pin === pairInfo.pin) {
      judgeChangeFileInfo();
      if (isChangeFile) {
        modelKey = getDefaultIndex(oldFiles.length, oldFiles.map(item => item.modelKey));
      }
      return changeType === "add"
        ? {
          ...pair,
          libraryId: fileValue.libraryId,
          modelKey,
          subckt: fileValue.subckt,
          node,
        }
        : {
          ...pair,
          libraryId: "",
          modelKey: "",
          subckt: "",
          node: "",
        }
    }

    return pair;
  });

  let newFiles = [...oldFiles];
  if (isChangeFile) {
    if (changeType === 'add') {
      const oldFile = newFiles.find(file => file.libraryId === fileValue.libraryId);
      newFiles.push({
        ...oldFile,
        modelKey
      });
    } else {
      newFiles = newFiles.filter(file => file.libraryId === pairInfo.libraryId && file.modelKey === pairInfo.modelKey);
    }
  }

  // if (otherKeyStr === DIE_TERMINATION) {
  //   modelList[modelIndex].termination.pairs = newPairs;
  //   modelList[modelIndex].termination.files = newFiles;
  // } else {
  //   modelList[modelIndex].pairs = newPairs;
  //   modelList[modelIndex].files = newFiles;
  // }

  modelList[modelIndex].pairs = newPairs;
  modelList[modelIndex].files = newFiles;

  const newComponents = [...components];
  newComponents[compIndex] = {
    ...components[compIndex],
    modelList
  }

  return resType === 'object' ? { newComponents, newPairs } : newComponents;
}

/**
 * 
 * @param {Object} file 
 * @param {'tx' | 'rx'} type 
 * @param {string} modelType
 * @param {number} modelIndex
 * @param {Array} components 
 * @param {Object} currentComp 
 */
function handleDeleteModelFile(file, type, modelType, modelIndex, components, currentComp) {
  let component = currentComp;
  if (type === 'tx') {
    component = components.find(item => item.name === file.comp) || {};
  }

  const judgeDeleteFileInfo = (data) => (data.modelKey === file.modelKey && data.libraryId === file.libraryId && (data.subckt === file.subckt || !file.subckt))

  const newComponents = components.map(compInfo => {
    if (compInfo.name !== component.name) { return compInfo }

    const { modelList = [] } = compInfo || {};
    // const oldPairs = modelType === DIE_TERMINATION ? modelList[modelIndex].termination.pairs : modelList[modelIndex].pairs;
    // const oldFiles = modelType === DIE_TERMINATION ? modelList[modelIndex].termination.files : modelList[modelIndex].files;
    const { pairs: oldPairs, files: oldFiles } = modelList[modelIndex];

    const newPairs = oldPairs.map(pair => {
      if (judgeDeleteFileInfo(pair)) {
        return {
          ...pair,
          libraryId: "",
          modelKey: "",
          subckt: "",
          node: "",
        }
      }

      return pair;
    })

    const newFiles = oldFiles.filter(item => !judgeDeleteFileInfo(item));
    // if (modelType === DIE_TERMINATION) {
    //   modelList[modelIndex].termination.pairs = newPairs;
    //   modelList[modelIndex].termination.files = newFiles;
    // } else {
    //   modelList[modelIndex].pairs = newPairs;
    //   modelList[modelIndex].files = newFiles;
    // }

    modelList[modelIndex].pairs = newPairs;
    modelList[modelIndex].files = newFiles;
    return {
      ...compInfo,
      modelList
    }
  });

  return newComponents;
}

function changeTerminationValue(value, pairInfo, modelIndex, components) {
  const compIndex = components.findIndex(item => item.name === pairInfo.comp);
  if (compIndex < 0) return components;
  const { modelList = [] } = components[compIndex];
  const oldPairs = modelList[modelIndex].termination.pairs;
  const newPairs = oldPairs.map(pair => {
    if (pair.pin === pairInfo.pin) {
      return {
        ...pair,
        r: `${value} ohm`
      }
    }

    return pair;
  });

  modelList[modelIndex].termination.pairs = newPairs;
  const newComponents = [...components];
  newComponents[compIndex] = {
    ...components[compIndex],
    modelList
  }

  return newComponents;
}

/**
 * Perform a round of matching using the "display pairs" data, and then fill the matched data into the "pairs" within the component.
 * 1. pairs From the same company
 * 2. pairs From different companies
 */
// auto patch
function handleAutoMatchPort(matchType, fileInfo, portsObj, type, displayPairs, components, targetComps, modelIndex, /*modelType, topology*/ swapTypes) {
  // 1. update files, Obtain the "newFile" data and fill in the "pair" with the required "modelKey"
  const newModelKeyObj = {}; // compName -> modelKey
  for (const comp of targetComps) {
    const { files } = comp.modelList[modelIndex]
    const modelKey = getDefaultIndex(files.length, files.map(item => item.modelKey));
    newModelKeyObj[comp.name] = modelKey
  }
  const targetCompNames = targetComps.map(comp => comp.name);
  // --> matchType === maunul
  if (matchType === "manual") {
    let isUpdate = false;
    const newComponents = components.map(comp => {
      if (!targetCompNames.includes(comp.name)) return comp;

      const modelList = comp.modelList;
      const { files } = modelList[modelIndex];
      const isExist = files.find(item => item.libraryId === fileInfo.libraryId && (!fileInfo.subckt || item.subckt === fileInfo.subckt))
      if (isExist) {
        return comp;
      }
      isUpdate = true;
      files.push({ ...fileInfo, modelKey: newModelKeyObj[comp.name] });
      modelList[modelIndex] = { ...modelList[modelIndex], files };
      return {
        ...comp,
        modelList
      }
    });

    return isUpdate ? newComponents : false;
  }

  // 2. get usable ports
  const portsFile = (portsObj[fileInfo.libraryId] || []).find(item => item.fileName === fileInfo.fileName) || {};
  const ports = (portsFile.ports || []).map(item => Object.hasOwn(item, "port") ? item.port : item);
  if (!ports || !ports.length) {
    return false;
  }

  // 3. obtain port
  let startIndex = -1, endIndex = -1, startAdd = 0, endAdd = 0;
  const indexInfo = getPortIndex(matchType - 1, ports.length, swapTypes);
  startIndex = indexInfo.startIndex;
  endIndex = indexInfo.endIndex;
  startAdd = indexInfo.startAdd;
  endAdd = indexInfo.endAdd;

  let portNumber = 0;
  const newDisplayPairs = displayPairs.map(pair => {
    const { pair_out, pair_in } = pair;
    let pair_left = type === 'tx' ? pair_out : pair_in;
    let pair_right = type === 'tx' ? pair_in : pair_out;
    const leftNode = portNumber < ports.length ? ports[startIndex] : "";
    pair_left = {
      ...pair_left,
      node: leftNode || "",
      fileName: fileInfo.fileName,
      libraryId: fileInfo.libraryId,
      modelKey: newModelKeyObj[pair_left.comp],
      subckt: fileInfo.subckt
    }
    if (ports[startIndex]) portNumber++;
    const rightNode = portNumber < ports.length ? ports[endIndex] : "";
    // pair_right = modelType === DIE && topology === PARALLEL ? pair_right
    pair_right = {
      ...pair_right,
      node: rightNode || "",
      fileName: fileInfo.fileName,
      libraryId: fileInfo.libraryId,
      modelKey: newModelKeyObj[pair_right.comp],
      subckt: fileInfo.subckt
    }
    if (ports[endIndex]) portNumber++;

    endIndex += endAdd;
    startIndex += startAdd;
    return [pair_left, pair_right];
  }).flat();

  const newComponents = components.map(comp => {
    if (!targetCompNames.includes(comp.name)) return comp;

    const modelList = comp.modelList;
    const { pairs, files } = modelList[modelIndex];
    files.push({ ...fileInfo, modelKey: newModelKeyObj[comp.name] });

    const newPairs = pairs.map(pair => {
      const newPair = newDisplayPairs.find(p => p.pin === pair.pin && p.comp === comp.name);
      if (!newPair) return pair;

      return {
        ...pair,
        node: newPair.node,
        libraryId: newPair.libraryId,
        modelKey: newPair.modelKey,
        subckt: newPair.subckt,
      }
    })
    // filter unusable file
    const newFiles = filterUnusedModelFiles(files, newPairs);
    modelList[modelIndex] = { ...modelList[modelIndex], pairs: newPairs, files: newFiles };
    return {
      ...comp,
      modelList
    }
  });
  return newComponents;
}

function getPortIndex(type, portLength, swapTypes = []) {
  if (portLength < 2) {
    return {
      startIndex: 0,
      endIndex: 0,
      startAdd: 0,
      endAdd: 0,
    }
  }
  const isHorizontal = swapTypes.includes(type + 1);
  let startIndex = -1, endIndex = -1, startAdd = 0, endAdd = 0;
  switch (type) {
    case 0:
      startIndex = isHorizontal ? 1 : 0;
      endIndex = isHorizontal ? 0 : 1;
      startAdd = 2;
      endAdd = 2;
      break;
    case 1:
      startIndex = isHorizontal ? Math.ceil(portLength / 2) : 0;
      endIndex = isHorizontal ? 0 : Math.ceil(portLength / 2);
      startAdd = 1;
      endAdd = 1;
      break;
    case 2:
      startIndex = isHorizontal ? portLength - 1 : 0;
      endIndex = isHorizontal ? 0 : portLength - 1;
      startAdd = isHorizontal ? -1 : 1;
      endAdd = isHorizontal ? 1 : -1;
      break;
    default:
      break;
  }

  const isVertical = swapTypes.includes(-(type + 1));
  if (isVertical) {
    const _startIndex = startIndex, _endIndex = endIndex;
    switch (type) {
      case 0:
        startIndex = startIndex === 1 ? portLength - 1 : portLength - 2;
        endIndex = endIndex === 1 ? portLength - 1 : portLength - 2;
        break;
      case 1:
        startIndex = startIndex === 0 ? _endIndex - 1 : portLength - 1;
        endIndex = endIndex === 0 ? _startIndex - 1 : portLength - 1;
        break;
      case 2:
        startIndex = startIndex === 0 ? Math.ceil(portLength / 2) - 1 : Math.ceil(portLength / 2);
        endIndex = endIndex === 0 ? Math.ceil(portLength / 2) - 1 : Math.ceil(portLength / 2);
        break;
      default:
        break;
    }

    startAdd = -startAdd;
    endAdd = -endAdd;
  }

  return {
    startIndex,
    endIndex,
    startAdd,
    endAdd,
  }
}

function editModelTypeByComponents(modelType, modelIndex, components, targetComps) {
  const targetCompNames = targetComps.map(item => item.name);
  const newComponents = components.map(item => {
    if (!targetCompNames.includes(item.name)) { return item }
    const { modelList = [] } = item || {};
    modelList[modelIndex] = {
      ...modelList[modelIndex],
      modelType
    }
    return { ...item, modelList }
  })

  return newComponents;
}

function handleAutoMatchPinList(pinList) {
  return pinList.map(item => {
    const { pinLeft, pinRight } = item;
    return {
      ...item,
      pinLeft: pinRight,
      pinRight: pinLeft
    }
  })
}

export {
  addNewModelToComponents,
  deleteOldModelByComponents,
  changePort,
  handleDeleteModelFile,
  changeTerminationValue,
  handleAutoMatchPort,
  editModelTypeByComponents,
  handleAutoMatchPinList
};